import * as React from 'react';
import { ActionBarButton } from './ActionBarButton';
import { IButtonRendererProps } from './ActionBarButtonTypes';

export const ButtonRenderer: React.FC<IButtonRendererProps> = ({ allButtons, visibleButtons }) => {
	return (
		<>
			{allButtons
				.filter(button => visibleButtons.includes(button.key))
				.map(button => {
					// Regular button with no dropdown
					return (
						<ActionBarButton
							key={button.key}
							icon={button.icon}
							onClick={button.onClick}
							disabled={button.disabled}
							styleClass={button.styleClass}
							actionButtonType={button.actionButtonType}
						>
							{button.children}
						</ActionBarButton>
					);
				})}
		</>
	);
};
